import React, { Component } from "react";
import { Spinner } from "../../Components/Spinner/Spinner";
import { callAPI } from "../../assets/Js/backendCommunication";
import projectSettings from "../../assets/Js/projectSettings";

import SearchBox from "../../Components/SearchBox/SearchBox";
import { marketPlaceParam } from "../../assets/Js/paramName";
import NewMarketplaceTrackCard from "../../Components/MarketplaceTrackCard/NewMarketplaceTrackCard";
import DisplayPicture from "../../Components/DisplayPicture/DisplayPicture";

export default class MarketplaceTrackList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      Id: null,
      AllTrack: [],
      SelectedTrackList: [],
      gymName: "",
      gymImage: "",
      gymTagline: "",
      gymAddress: "",
      search: "",
    };
  }

  componentDidMount() {
    const paramName = marketPlaceParam;
    let search = this.props.location.search;
    const paramValue = new URLSearchParams(search).get(paramName);

    let _id = this.props.match.params.id;
    this.setState({
      Id: _id,
      queryParams: search,
      paramName,
      paramValue,
    });
    this.getTracks(_id);
  }

  getTracks = async (id) => {

    let url = `${projectSettings.baseUrl}/gyms/${id}/tracks`;

    let header = true;
    let type = "GET";
    let token = null;
    let data = null;

    let response = "";

    if (response === "") {
      this.setState({ isLoading: true });
    }

    response = await callAPI(url, header, type, data, token);

    if (response) {

      this.setState({ isLoading: false});
      if (response.type === "error") {
      } else if (response.type === "success") {
        if (response.data) {
          this.setState({ gymName : response.data.Name, gymImage : response.data.Image, gymTagline : response.data.Tagline, gymAddress : response.data.Address });

          let _tracks = response.data.Tracks.map((track) => ({
            id: track.Id,
            name: track.Name,
            price: track.Price,
            type: track.Type,
            image: track.Image,
            joinPassword: track.JoinPassword,
            trialPeriodDays: track.TrialPeriodDays,
            isTrackJoinned: track.IsTrackJoined,
            description: track.Description,
          }));

          this.setState({ AllTrack: _tracks, SelectedTrackList: _tracks });
        }
        response = "";
      }
    }
  };

  changeHandler = (targetData) => {
    this.setState({
      SelectedTrackList: targetData,
    });
  };

  gotoGymListPage = () => {
    this.props.history.goBack();
  };

  render() {
    return (
      <>
        <div className="container-fluid content-wrapper" style={{ padding: "0" }}>
        <section class="hero-section">
          <div class="hero-content">
            <h1 className="mb-3">{this.state.gymName}</h1>
            <p> {this.state.Tagline} </p>
              <p> {this.state.gymAddress} </p>
          </div>
          <DisplayPicture image={this.state.gymImage} showGymAvatar={true}/>
        </section>
            <div className="row justify-content-center">
              <div className="col-md-6">
                <div className="container">
                  <div className="searchContainer mb-3">
                    <button
                      className="noBgBtn"
                      onClick={this.gotoGymListPage}
                    >
                      <span className="mdi mdi-arrow-left mr-2 pl-0 ml-0"></span>
                    </button>
                    <h2 style={{ fontWeight: "400" }}>
                    {this.state.SelectedTrackList.length} total track(s)
                  </h2>
                  <SearchBox
                    data={this.state.AllTrack}
                    propertyToLookFor={"name"}
                    placeholder="Search a track"
                    changeHandler={this.changeHandler}
                    searchBoxStyles="col-md-4"
                  />
                  </div>
                </div>
                <div className="listings container">
                  {this.state.isLoading ? (
                    <div>
                      <Spinner />
                    </div>
                  ) : this.state.SelectedTrackList.length ? (
                    <div>
                      {this.state.SelectedTrackList?.map((currVal, index) => (
                        <NewMarketplaceTrackCard
                          id={currVal.id}
                          name={currVal.name}
                          image={currVal.image}
                          price={currVal.price}
                          type={currVal.type}
                          joinPassword={currVal.joinPassword}
                          trialPeriodDays={currVal.trialPeriodDays}
                          isTrackJoinned={currVal.isTrackJoinned}
                          description={currVal.description}
                        />
                      ))}
                    </div>
                  ) : this.state.SelectedTrackList.length === 0 &&
                    !this.state.isLoading ? (
                    <div className="mt-3 text-center">No Tracks Found</div>
                  ) : null}
                </div>
              </div>
            </div>
        </div>
      </>
    );
  }
}
